// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2Dodp","options":"AnswerScale_options__34l6g","selected":"AnswerScale_selected__25g_D"};